export enum ERole {
  ADMIN = 'admin',
  USER = 'user',
}
